const Education = () => {
  return (
    <section className="resume-section" id="education">
      <div className="resume-section-content">
        <h2 className="mb-5">Education</h2>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">Jinan University of Lebanon</h3>
            <div className="subheading mb-3">Bachelor Computer Science</div>
            <ul>
              <li>Graduated with 84.75%</li>
              <li>Got creativity certification on graduation party.</li>
              <li>Complete multiple project from Small to mid size in team.</li>
            </ul>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">Jul 2020 - Aug 2023</span>
          </div>
        </div>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">TECHlarious</h3>
            <div className="subheading mb-3">MERN STACK development BootCamp</div>
            <ul>
              <li>
                Participate in more than 80 Hours of learning MERN stack and Gain Basic Knowledge in full stack web
                development.
              </li>
              <li>Attend soft skills sessions.</li>
              <li>
                Participate in more than 4 - 5 Project in front end using Vanilla JavaScript and ReactJS and back end
                project using ExpressJS and MongoDB database.
              </li>
            </ul>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">Jan 2023 - Apr 2023</span>
          </div>
        </div>
        {/* <div className="d-flex flex-column flex-md-row justify-content-between">
          <div className="flex-grow-1">
            <h3 className="mb-0">Many Certifications</h3>
            <div className="subheading mb-3">IT Field</div>
            <ul>
              <li>Python Course</li>
              <ul>
                <li>Crush Course on Python from Google - <a href="https://coursera.org/share/ec34a9cfbbe3d372e8862f7821e20c3e">Coursera</a></li>
                <li>Using Python to Interact with the Operation System from Google - <a href="https://coursera.org/share/bab5aa375d8ceec0ac68a1bdd5506003">Coursera</a></li>
              </ul>

              <div className="subheading mb-2"></div>

              <li>Cyber Security</li>
              <ul>
                <li>Cyber Security Fundamentals from University of London - <a href="https://coursera.org/share/f5c3b34142a89587341fa83b8706670b">Coursera</a></li>
                <li>Foundations of Cybersecurity from Google - <a href="https://coursera.org/share/83aa33ee67a551a676e1209351f5edc1">Coursera</a></li>
              </ul>

              <div className="subheading mb-2"></div>

              <li>Technical Support</li>
              <ul>
                <li>Technical Support Fundamentals from Google - <a href="https://coursera.org/share/c182f5dff5c8fae4fa3e9d5bd319399f">Coursera</a></li>
                <li>Operating Systems and You: Becoming a Power User from Google - <a href="https://coursera.org/share/55365f2d28c854d68f751e472e6825b1">Coursera</a></li>
                <li>Tools of the Trade: Linux and SQL from Google - <a href="https://coursera.org/share/ac7f61e19d9ff4922505856a73f1d11d">Coursera</a></li>
                <li>Using Python to Interact with the Operation System from Google - <a href="https://coursera.org/share/bab5aa375d8ceec0ac68a1bdd5506003">Coursera</a></li>
              </ul>

              <div className="subheading mb-2"></div>

              <li>Angular</li>
              <ul>
                <li>Angular - Complete Guide 2023 - <a href="http://ude.my/UC-5d1bf5ef-b0e0-4fce-953b-0bba476f8f3b">Udemy</a></li>
                <li>Angular application architecture for beginnersAngular - <a href="https://www.udemy.com/certificate/UC-10836ab4-6c75-4477-979a-c5ba6904c914/">Udemy</a></li>
                <li>Create a responsive Angular application for beginnersCreate - <a href="https://www.udemy.com/certificate/UC-4e204372-0f0f-4197-bbd3-ac3bfd3abf13/">Udemy</a></li>
              </ul>
            </ul>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">Fall 2015 - Present</span>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Education;
